import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=c6336566&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6336566')) {
      api.createRecord('c6336566', component.options)
    } else {
      api.reload('c6336566', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=c6336566&", function () {
      api.rerender('c6336566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VutC123rHWFy/JS/pricehelp.vue"
export default component.exports